<template>
    <div>
        <v-card class="ma-2">
            <v-card-title test-tag="tag-252"><T>Фильтры</T></v-card-title>
            <v-card-text>
                <div style="width: 100%;" class="d-flex">
                    <DateFilter :minusDaysForStartDate="30" ref="dateFilter" />
                    <v-btn test-tag="tag-250"
                        class="mx-2"
                        fab
                        dark
                        color="success"
                        @click="updateData"
                    >
                        <v-icon dark>
                            mdi-autorenew
                        </v-icon>
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
        
        <v-card class="ma-2" style="height: 500px;">
            <Maps  :coordinates="allAddresses" />
        </v-card>

        <v-card class="ma-2">
            <v-card-title test-tag="tag-253"><T>Отчет по зонам доставки</T></v-card-title>
            <v-card-text>
                <v-data-table test-tag="tag-251"
                    :headers="headers"
                    :items="tableData"
                    :loading="tableLoad"
                    :loading-text="$t('Данные загружаются...')"
                    :no-data-text="$t('Данные не найдены')"
                    hide-default-footer
                >
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import DateFilter from '../../components/orders/DateFilter.vue';
import Maps from '../../components/Maps/Maps.vue';

export default {
    name: 'zonesReport',

    components: {
        DateFilter,
        Maps,
    },

    data() {
        return {
        tableData: [],
        tableLoad: false,
        headers: [],
        dateBegin: null,
        dateEnd: null,
        allAddresses: [] 
        }
    },

    async mounted() {
        this.resetTable();
    },

    methods: {
        async resetTable() {
        this.dateBegin = await this.$refs.dateFilter.getDateBegin();
        this.dateEnd = await this.$refs.dateFilter.getDateEnd();
        
        this.tableLoad = true;
        
        this.tableData = await this.$store.dispatch('getZonesDataTableInfo', { date_begin: this.dateBegin, date_end: this.dateEnd });
        
        this.allAddresses = this.tableData.reduce((acc, item) => {
            if (item.addreses && Array.isArray(item.addreses)) {
            return acc.concat(item.addreses);
            }
            return acc;
        }, []);

        const zones = new Set();
        this.tableData.forEach(item => {
            zones.add(item.delivery_zone);
        });
        const zonesArray = Array.from(zones);
        
        this.headers = [
            { text: this.$t('Дата'), value: 'date' },
            ...zonesArray.map(zone => ({ 
                text: this.$t('Зона') + ' '+'"' + this.$store.getters.local_refs.geocoding.zones[zone].name + '"', 
                align: 'center', value: zone 
            })),
            { 
                text: this.$t('Итого за дату'), align: 'center', 
                value: 'total' 
            }];
            
            const groupedData = {};
            this.tableData.forEach(item => {
                const date = item.date;
                if (!groupedData[date]) {
                    groupedData[date] = { date, total: 0 };
                }
                groupedData[date][item.delivery_zone] = item.count;
                groupedData[date].total += item.count;
            });
            this.tableData = Object.values(groupedData);
            this.tableData.map(el => {
                el.date = this.dateFormat(el.date);
            });
            
            this.tableLoad = false;
        },

        async updateData() {
            this.resetTable();
        },

        dateFormat(date) {
            const [year, month, day] = date.split('-');
            return `${day}.${month}.${year}`;
        }
    }
}
</script>

<style scoped>

</style>